// extracted by mini-css-extract-plugin
module.exports = {"search":"SimpleList_search__1H21F","itemCell":"SimpleList_itemCell__1I8GV"};